<template>
    <div :class='{ fixedNavbar: isfixTab }' id="testNavBar">
      <h2 @click="getData(1,null,null)">{{bigTitle}}</h2>
      <div class="tableBlock">
        <dl v-for="item in headerTitle" :key="item.id">
          <dt  @click="getData(1,item.id,null)">{{item.name}}</dt>
          <dd v-for="item1 in item.myArticleClassifyDtoList" :key="item1.id" @click="getData(1,item.id,item1.id)"><span v-html="item1.name"></span></dd>
        </dl>
    </div>

      <ul class="imageBlock">
        <li v-for="item in tableData" :key="item.articleId">
          <router-link :to="{name:'Info',params:{id:item.articleId}}"  target="_blank"><img :src="item.smallPic" class="img" /> </router-link>
          <router-link :to="{name:'Info',params:{id:item.articleId}}"  target="_blank"><img :src="item.reverseSmallPic" class="img" /></router-link>
            
              <div class="txt">
                <!-- <h3> <router-link :to="{name:'Info',params:{id:item.articleId}}"  target="_blank"><span v-if="item.country!=undefined && item.country.length>0">{{item.country}}</span><span v-if="item.classifyName!=undefined && item.classifyName.length>0">-{{item.classifyName}}</span><span v-if="item.thisYear!=undefined && item.thisYear.length>0">-{{item.thisYear}}</span></router-link></h3> -->
                  <h3> 
                    <router-link :to="{name:'Info',params:{id:item.articleId}}"  target="_blank">
                    <div v-if=" item.bigType == 246 || item.bigType==247 || item.bigType==248 || item.bigType==249 
                    || item.bigType==250 || item.bigType==253 || item.bigType==254 || item.bigType==255 
                    || item.bigType==256 || item.bigType==257 || item.bigType==258 || item.bigType==259 ">
                      <span v-if="item.country!=undefined && item.country.length>0">{{item.country}}</span><span v-if="item.frontDesc!=undefined && item.frontDesc.length>0">-{{item.frontDesc}}</span><span v-if="item.classifyName!=undefined && item.classifyName.length>0">-{{item.classifyName}}</span><span>{{item.castMark}}</span>
                    </div>
                    <div v-else>
                      <span v-if="item.country!=undefined && item.country.length>0">{{item.country}}</span><span v-if="item.classifyName!=undefined && item.classifyName.length>0">-<span v-html="item.classifyName"></span></span><span v-if="item.thisYear!=undefined && item.thisYear.length>0">-{{item.thisYear}}</span><span>{{item.castMark}}</span>
                    </div>
                  </router-link>
                </h3>
                <i style="color:#333;"><span v-if="item.coinTypeName!=undefined && item.coinTypeName.length>0">{{item.coinTypeName}}</span><span v-if="item.weight!=undefined && item.weight.length>0">,{{item.weight}}克</span><span v-if="item.diameter!=undefined && item.diameter.length>0">,{{item.diameter}}毫米</span><span v-if="item.thick!=undefined && item.thick.length>0">,{{item.thick}}毫米</span></i><br />
                <i style="color:#333;"><span v-if="item.component!=undefined && item.component.length>0">{{item.component}}</span> <span v-if="item.shape!=undefined && item.shape.length>0">,{{item.shape}}</span> <span v-if="item.edge!=undefined && item.edge.length>0">,{{item.edge}}</span></i><br />
                <span style="color:#666;">{{item.frontDesc}}</span><br />
                <span style="color:#666;">{{item.backDesc}}</span>
              </div>
           
            <div style="clear:both;"></div>
        
          
        </li>
      </ul>
      <div class="tabListPage">
             <el-pagination @size-change="handleSizeChange" 
                            @current-change="handleCurrentChange" 
                            :current-page="currentPage" 
                            :page-sizes="pageSizes" 
                            :page-size="PageSize" layout="total, sizes, prev, pager, next, jumper" 
                            :total="totalCount">
               </el-pagination>
      </div>  
    
    </div>
  </template>

<script>
import axios from "axios";
export default {
    name: "RightContent",
    props:["smallType","bigTitle"],
    components: {

    },
    data(){
        return{
                 // 总数据
                tableData:[],
                // 默认显示第几页
                currentPage:1,
                // 总条数，根据接口获取数据长度(注意：这里不能为空)
                totalCount:1,
                // 个数选择器（可修改）
                pageSizes:[10],
                // 默认每页显示的条数（可修改）
                PageSize:10,
                isfixTab:false,
                headerTitle:[],
                classifyArr:[],
                classifyId:null,
                deci:null,      
        }
    },
    created:function(){
      
       //this.handleTabFix();
    },
    mounted () {
      this.getHeadTitle();
      this.getData(this.currentPage,this.deci,this.classifyId);
       //window.addEventListener('scroll', this.handleTabFix, true)
    },
    // beforeRouteLeave (to, from, next) {
    //   window.removeEventListener('scroll', this.handleTabFix, true)
    //   next()
    // },
    methods:{
      getHeadTitle(){
            var _this = this;
            axios.get(this.COMMON.httpUrl + '/api/header/getDeciListBySmallTypeId', {
            params: {
              smallTypeId:_this.smallType
            }
          }).then(function (response) {
            var data = response.data;
            _this.headerTitle=data.data;
          }).catch(function (error) {
            console.log(error)
          });
      },
      getClassify(deciId){
        var _this = this;
        axios.get(this.COMMON.httpUrl + '/api/classify/getListByOnlyDeci', {
            params: {
              deci:deciId
            }
          }).then(function (response) {
            var data = response.data;
            _this.classifyArr=data.data;
          }).catch(function (error) {
            console.log(error)
          });
      },
      getData(currentPage,deci,classifyId){
            var _this = this;
            _this.deci = deci;
            _this.classifyId = classifyId;
            axios.get(this.COMMON.httpUrl + '/api/article/page', {
            params: {
              page: currentPage,
              limit: _this.PageSize,
              smallType:_this.smallType,
              classifyId:_this.classifyId,
              deci:_this.deci
            }
          }).then(function (response) {
            var data = response.data;
            _this.tableData=data.data;
            _this.totalCount = data.count;
          }).catch(function (error) {
            console.log(error)
          });
        },
      // 分页
        // 每页显示的条数
      handleSizeChange(val) {
          // 改变每页显示的条数 
          this.PageSize=val
          // 注意：在改变每页显示的条数时，要将页码显示到第一页
          this.currentPage=1
      },
        // 显示第几页
      handleCurrentChange(val) {
          // 改变默认的页数
          this.currentPage=val
          this.getData(val,this.deci,this.classifyId);
      },
      handleTabFix() {
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
        var offsetTop = document.querySelector('#testNavBar').offsetTop
        scrollTop-260 > offsetTop ? this.isfixTab = true : this.isfixTab = false
      }
  }
}
</script>


<style scoped>

h2{cursor: pointer;}
ul.imageBlock{ width: 100%; overflow: hidden; margin-top: 20px; clear: both;}
ul.imageBlock li{width: 100%;min-height: 135px; overflow: hidden; padding-bottom: 20px; border-bottom: 1px solid #ccc; margin-bottom: 20px; }
ul.imageBlock li img{border: 1px solid #E5E5E5; float: left; margin-right: 10px; margin-bottom: 5px;width: 140px; height: 140px;}
ul.imageBlock li .txt{margin-left: 10px; float:left;line-height: 180%;overflow: hidden; width: 360px;}
ul.imageBlock li .txt h3{font-size: 20px; margin-bottom: 6px;}
ul.imageBlock li .txt h3 a{text-decoration: none;color: rgb(179, 0, 0);}
.fixedNavbar {
      position:fixed;
      z-index: 2032;
      top: 10px;
      height: 1000px;
      float: both;
    }
.img{border-radius: 10px;}
.tableBlock{margin-top: 14px;  height: auto;  padding-bottom: 26px; 
  max-height: 120px; overflow: hidden;overflow-y:auto;
}
dl{ clear: both; font-size: 12px; padding-bottom: 10px;  }
dt{float: left;margin: 5px;padding: 4px; margin-right: 10px;height: 20px; line-height: 16px; overflow: hidden;  font-weight: bold; color: #666;cursor: pointer;}
dd{float: left; margin: 5px;overflow: hidden; height: 20px; line-height: 16px; background: #eee; padding: 4px;color: #666;border-radius:4px; cursor: pointer;}
</style>
